import dayjs from 'dayjs'
import {
  TaskTrackerBoardCard,
  UpdateTaskTrackerTaskRequest,
} from '../store/taskTracker.types'
import { areTaskPerformerIdsEqual } from './taskTrackerPerformers.utils'

export type TaskInfoFormState = {
  isCompleted: boolean
  performerIds: number[]
  deadline: string | null
}

export const formatTaskDeadline = (value: string | null) => {
  if (!value) return '—'

  const date = dayjs(value)
  if (!date.isValid()) return '—'

  return date.format('DD.MM.YYYY')
}

export const normalizeTaskDeadline = (value: string | null | undefined) => {
  if (!value?.trim()) return null

  const date = dayjs(value)
  if (!date.isValid()) return null

  return date.format('YYYY-MM-DD')
}

export const mapTaskToInfoFormState = (
  task: TaskTrackerBoardCard | null,
): TaskInfoFormState => ({
  isCompleted: Boolean(task?.isCompleted),
  performerIds: task?.performerIds ?? [],
  deadline: normalizeTaskDeadline(task?.deadline),
})

export const buildTaskInfoUpdatePayload = (
  current: TaskInfoFormState,
  snapshot: TaskInfoFormState,
): UpdateTaskTrackerTaskRequest => {
  const payload: UpdateTaskTrackerTaskRequest = {}

  if (current.isCompleted !== snapshot.isCompleted) {
    payload.is_completed = current.isCompleted
  }

  if (!areTaskPerformerIdsEqual(current.performerIds, snapshot.performerIds)) {
    payload.performer_ids = current.performerIds
  }

  if (current.deadline !== snapshot.deadline) {
    payload.deadline = current.deadline
  }

  return payload
}
